import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import * as paths from 'Paths';


const InvoicesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/billing/invoices" */
    'routes/Billing/InvoicesRoute'
  )
));

const InvoiceItemsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/billing/invoice-items" */
    'routes/Billing/InvoiceItemsRoute'
  )
));

const InvoiceRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/billing/invoice" */
    'routes/Billing/InvoiceRoute'
  )
));

const CreditsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/billing/credits" */
    'routes/Billing/CreditsRoute'
  )
));

const SubscriptionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/billing/subscriptions" */
    'routes/Billing/SubscriptionsRoute'
  )
));

const UpdateSubscriptionRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/billing/update-subscription" */
    'routes/Billing/UpdateSubscriptionRoute'
  )
));

const UsagesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/billing/usages" */
    'routes/Billing/UsagesRoute'
  )
));


const getBillingRoutes = () => {
  return [
    {path: paths.getPathInvoices(), component: InvoicesRoute},
    {path: paths.getPathInvoiceItems(), component: InvoiceItemsRoute},
    {path: paths.getPathInvoice(":invoiceId"), component: InvoiceRoute},
    {path: paths.getPathCredits(), component: CreditsRoute},

    {path: paths.getPathSubscriptions(), component: SubscriptionsRoute},
    {path: paths.getPathAddSubscription(":product"), component: UpdateSubscriptionRoute},
    {path: paths.getPathEditSubscription(":subscriptionId"), component: UpdateSubscriptionRoute},
    {path: paths.getPathUsages(), component: UsagesRoute},
  ]
}



export { getBillingRoutes };
